import { EntityProject } from "../../entity/EntityProject";

export class DtoProjectsDeleteRes extends EntityProject {
  public message: string | null = null;
}
